var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"form-control",class:_vm.inputClass,attrs:{"type":"text","id":_vm.name,"placeholder":_vm.label,"disabled":_vm.disabled,"autocomplete":"off"},domProps:{"value":_vm.computedValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }